import type { NativeSession } from "../native/session";
import {
  buildNativeMaterial,
  materialHTML,
  resultFiles,
} from "../player/native-export";
import { downloadBlob } from "./native-files";
import type { ZipProvider } from "../adapters/jszip-project";
import { blobDataURL } from "../adapters/blob-data-url";
/** Builds from an immutable snapshot. Preview navigation and attempts stay in the preview window. */
export class NativePreview {
  busy = false;
  constructor(
    private session: NativeSession,
    private prepare: () => boolean,
    private message: (s: string, error?: boolean) => void,
  ) {
    const menu = document.querySelector(".save-menu-panel")!;
    for (const [id, label, run] of [
      ["native-preview", "Предпросмотр", () => this.run(false)],
      ["native-export-zip", "Скачать HTML/ZIP", () => this.run(true)],
    ] as const) {
      const b = document.createElement("button");
      b.id = id;
      b.textContent = label;
      b.onclick = () => void run();
      menu.append(b);
    }
  }
  private async run(zip: boolean) {
    if (this.busy || !this.prepare()) return;
    (document.getElementById("save-menu") as HTMLDetailsElement).open = false;
    const preview = zip ? null : window.open("", "_blank");
    if (!zip && !preview) {
      this.message(
        "Браузер заблокировал предпросмотр. Разрешите всплывающие окна.",
        true,
      );
      return;
    }
    if (preview) {
      preview.document.title = "Предпросмотр";
      preview.document.body.textContent = "Подготавливаем страницы…";
    }
    this.busy = true;
    const snapshot = structuredClone(this.session.document);
    try {
      const material = await buildNativeMaterial(snapshot);
      if (zip) {
        const Zip = (window as unknown as { JSZip: ZipProvider }).JSZip,
          z = new Zip();
        for (const p of material.pages)
          z.file(p.name + ".html", materialHTML(p));
        for (const [name, blob] of material.assets)
          z.file(name, new Uint8Array(await blob.arrayBuffer()));
        for (const [name, value] of Object.entries(resultFiles()))
          z.file(name, value);
        downloadBlob(
          await z.generateAsync({
            type: "blob",
            compression: "DEFLATE",
            compressionOptions: { level: 6 },
          }),
          "project.zip",
        );
        this.message("Интерактивный проект сохранён в ZIP.");
      } else if (preview && !preview.closed) {
        const inline = new Map<string, string>();
        for (const [name, blob] of material.assets)
          inline.set(name, await blobDataURL(blob));
        const pages = Object.fromEntries(
          material.pages.map((p) => [p.name, materialHTML(p, inline)]),
        );
        const start = snapshot.pages.find(
          (p) => p.id === snapshot.activePageId,
        )!.exportName;
        // iframe.srcdoc prevents document.write from invalidating the parent navigation state.
        const payload = JSON.stringify({ pages, start }).replace(
          /</g,
          "\\u003c",
        );
        preview.document.open();
        preview.document.write(
          `<!doctype html><html lang="ru"><meta charset="utf-8"><title>Предпросмотр</title><style>body{margin:0}iframe{width:100%;height:100vh;border:0;display:block}</style><iframe title="Интерактивный материал"></iframe><script>const material=${payload};const frame=document.querySelector('iframe');let attempt=null;function show(name){const html=material.pages[name];if(!html)return false;frame.srcdoc=html;return true;}window.creatorEnginePreview={show,read:()=>attempt||{attemptId:'preview-'+Date.now(),studentName:'',startedAt:'',lastActivityAt:'',currentScreenId:'',lastResult:0,totalResult:0,screens:{}},write:data=>{attempt=data;}};show(material.start);</script></html>`,
        );
        preview.document.close();
      }
    } catch (e) {
      this.message((e as Error).message, true);
      if (preview && !preview.closed)
        preview.document.body.textContent = (e as Error).message;
    } finally {
      this.busy = false;
    }
  }
}
